import { render } from "./PurchaseReceiveBoard.vue?vue&type=template&id=16bbce40&scoped=true"
import script from "./PurchaseReceiveBoard.vue?vue&type=script&lang=js"
export * from "./PurchaseReceiveBoard.vue?vue&type=script&lang=js"

import "./PurchaseReceiveBoard.vue?vue&type=style&index=0&id=16bbce40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bbce40"]])

export default __exports__